import { useIntlModule } from 'utils/intl/useIntlModule';
import messages from './jobFamilyGroups.intl.json';

export const useJobFamilyGroupsIntl = () => useIntlModule(messages);
